<template>
  <div class="contact">
    <div class="swiper">
      <img class="swiper-img" :src="backgroundImg" alt="">
      <el-carousel :interval="3000" arrow="always">
        <el-carousel-item v-for="(item, index) in swiperImg" :key="index">
          <a :href="item.bannerUrl" v-if='(item.bannerUrl != "http://int.ehsy.com") && (item.bannerUrl != "https://int.ehsy.com")'>
            <img class="swiper-img" :src="item.bannerImg" alt="">
          </a>
          <img class="swiper-img" :src="item.bannerImg" alt="" v-else >
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="product">
      <div class="product-list">
        <div class="list-title">
          <span class='line'></span>
          <span class="big-classify">CONTACT  US</span>
          <span class='line'></span>
        </div>
        <div class="list-intro">Email: int@ehsy.com</div>
        <div class="list-intro">Address: Sunplus Building 4th ﬂoor, 1077 Zuchongzhi Rd, </div>
        <div class="list-intro">Pudong New District, Shanghai 201203, China</div>
        <p class='list-intro'>(0086)18930217882</p>
      </div>
    </div>

    <div class="footer">
     @2020 EHSY.All rights reserved.
    </div>

  </div>
</template>

<script>

  export default {
    name: "home",
    data () {
      return{
        swiperImg: [],
        isPhone: null,
        backgroundImg:''
      }
    },
    created(){

      this.getBanner();
    },
    methods: {
      getBanner: function (){
        let _this = this;
        let params = {
          terminalType: 'int_contact_banner'
        }
        this.$http.get('pb/homepage/carousel/figures?terminalType=int_contact_banner', params).then(res => {
          if(res.body.mark == 0){
            _this.swiperImg = res.body.data;
            _this.backgroundImg =  _this.swiperImg[0].bannerImg;
          }else{
          }
        });
      }
    }
  }
</script>

<style scoped>

  /deep/ .el-carousel{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
  }
  /deep/ .el-carousel__container{
    height: 100%;
    width: 100%;
  }

  /deep/ .el-carousel__arrow{
    width: 4rem;
    height: 4rem;
    font-size: 2.5rem;
  }


  .contact{
    height:100%;
    display: flex;
    flex-direction: column;
  }

  .swiper{
    width:100%;
    position: relative;
  }
  .swiper .swiper-img{
    width: 100%;
  }
  .product{
    flex:1;
    padding:60px 60px 0;
    margin-bottom: 200px;
  }
  .product .product-list{
    width:100%;
    margin-top: 60px;
  }
  .product .product-list .list-title {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 60px;
  }
  .product .product-list .list-title .line{
    width: 100px;
    height: 1px;
    background: #b7b7b7;
  }
  .product .product-list .list-title .big-classify{
    font-size: 25px;
    font-weight: 600;
    margin: 0 60px;
  }
  .product .product-list .list-intro{
    font-size: 1.2rem;
    color: #777777;
    margin: 10px 0;
    text-align: center;
  }

  .footer{
    width: 100%;
    height: 2rem;
    line-height: 2rem;
    background: #e8e8e8;
    text-align: center;
    font-size: 0.8rem;
  }
  .footer.isPhone{
    height: 3rem;
    line-height: 3rem;
    background: #e8e8e8;
    text-align: center;
    font-size: 1rem;
    position: fixed;
    bottom: 0;
  }

</style>



// WEBPACK FOOTER //
// src/pages/contact/index.vue